
import Vue from 'vue';
import loginService from "@/services/loginService";
import msDataProvider from "@/services/msDataProvider";
import {required} from "@/plugins/validates";
import {LOGIN_TYPE_KEY, MSUITE_LOCAL_KEY} from "@/constant/login";
import LocalStorage from "@/services/localStorage";
import moment from "moment";

export default Vue.extend({
  name: "ServerAddress",
  props: ['type', 'hideOption'],
  data() {
    return {
      modalOptions: {
        title: this.$t('LOGIN.ADD_SERVER'),
        cancel: this.$t('APP.CLOSE'),
        ok: this.$t('APP.ADD'),
        titleClasses: 'font-22',
      },
      serverNameDialog: {
        backendServerName: '',
        createServerNameDialog: false,
        message: '',
        success: '',
        loading: false,
        errorMessage: "",
        valid: true
      },
      overlay: false,
      selectedItem: "",
      items: [],
      firstTime: null,
      backendServerNameSaving: "",
      backendServerName: localStorage.getItem('serverName') || sessionStorage.getItem('serverName'),
      loading: false,
      errorMessage: "",
      success: "",
      availableMethods: [''],
      loginService,
      required,
      MSUITE_LOCAL_KEY,
      isLoggedNoti: false,
      isLoggedNotiOpts: {},
      error: ""
    }
  },
  watch: {
    backendServerName() {
      if (this.errorMessage) {
        this.errorMessage = "";
      }
    },
    'loginService.prepareLoginResponse': {
      handler(val) {
        if (val) {
          this.availableMethods = val.available_login_methods || [];
        }
      },
      deep: true,
      immediate: true
    },
    'serverNameDialog.backendServerName': {
      handler() {
        if (this.serverNameDialog.errorMessage) {
          this.serverNameDialog.errorMessage = "";
        }
      }
    },
    'serverNameDialog.createServerNameDialog': {
      handler(val) {
        if (!val) {
          this.serverNameDialog = {
            backendServerName: '',
            createServerNameDialog: false,
            message: '',
            success: '',
            loading: false,
            errorMessage: "",
          }
        }
      }
    }
  },
  methods: {
    emit() {
      this.$emit('trigger', async () => {
        return await this.updateBackendServerName();
      })
    },
    goToListApp() {
      this.$router.push('/main/connection');
    },
    async updateBackendServerName() {
      this.loading = true;
      const isUpdateServerNameSucceed = await this.changeBackendServerName(false);
      if (isUpdateServerNameSucceed) {
        await this.prepare();
      }
      this.loading = false;
      this.setDefaultLoginType();
      return this.error ? null : isUpdateServerNameSucceed;
    },
    async prepare(params = {}) {
      this.error = "";
      try {
        const response = await msDataProvider.executeCommand(
            "authenPrepareLogin",
            params
        );
        if (response.new_backend_server_name) {
          location.reload();
          return;
        }
        this.availableMfas = {};
        if (response.available_mfas) {
          for (const mfa of response.available_mfas) {
            this.availableMfas[mfa] = true;
          }
        }
        loginService.setPrepareLoginResponse(response);
        if (response.error_info.error_code) {
          this.error = response.error_info.message;
          return;
        }
        if (!response.type) {
          this.$router.push("/prepare").catch((e) => e);
          return;
        }
      } catch (e) {
        this.error = e;
      }
    },
    async changeBackendServerName(loadingStandAlone: boolean = true) {
      if (!this.backendServerName) {
        return true;
      }
      try {
        if (loadingStandAlone) {
          this.loading = true;
        }
        await msDataProvider.executeCommand(
            "backendServerNamePing",
            this.backendServerName.trim()
        );
      } catch (e: any) {
        console.log(e)
        this.success = '';
        if (e && e.message) {
          if (e.message.includes('verify certificate: x509')) {
            this.errorMessage = this.$t('ERROR_SERVICE.ERROR_SSL_EXPIRED');
          } else {
            this.errorMessage = e.message.includes("Internet Connection Problem") ? this.$t('ERROR_SERVICE.ERROR_SERVICE_HOST_NAME') : this.$t('LOGIN.ERROR_SERVER')
          }
        }
        return false;
      } finally {
        if (loadingStandAlone) {
          this.loading = false;
        }
      }
      await msDataProvider.executeCommand(
          "backendServerNameSetCurrentValue",
          this.backendServerName.trim()
      );
      this.errorMessage = "";
      this.success = 'Máy chủ hợp lệ';
      this.backendServerNameShown = false;
      this.checkDomainIsLogged()
      return true;
    },
    selectItem(item) {
      this.selectedItem = item;
      const loginTypeList = LocalStorage.getItem(LOGIN_TYPE_KEY)
      LocalStorage.setItem(LOGIN_TYPE_KEY, {
        ...loginTypeList,
        [this.backendServerName]: item
      });
      const foundMethod = this.availableMethods?.find(
          loginMethod => loginMethod.name === item
      );
      if (foundMethod?.type === 'open_id_connect') {
        this.$router.push('/login/open_id_connect');
        return;
      }
      this.$router.push('/login/username_password');
    },
    setDefaultLoginType() {
      const listLoginType = LocalStorage.getItem(LOGIN_TYPE_KEY);
      if (listLoginType) {
        const loginType = listLoginType[this.backendServerName];
        if (!this.availableMethods.find(method => method.name === loginType)) {
          LocalStorage.setItem(LOGIN_TYPE_KEY, {
            ...listLoginType,
            [this.backendServerName]: MSUITE_LOCAL_KEY
          });
          this.selectedItem = MSUITE_LOCAL_KEY;
        } else {
          this.selectedItem = loginType;
        }
      } else {
        LocalStorage.setItem(LOGIN_TYPE_KEY, {
          [this.backendServerName]: MSUITE_LOCAL_KEY
        });
        this.selectedItem = MSUITE_LOCAL_KEY;
      }
    },
    async checkDomainIsLogged() {
      const authenInfo = await msDataProvider.getData("authenAuthenInfo");
      if (authenInfo.access_token_verifying &&
          authenInfo.token_info &&
          authenInfo.token_info.exp &&
          moment(authenInfo.token_info.exp * 1000).isAfter(moment(new Date()))
      ) {
        this.isLoggedNoti = true;
      }
    },
    async logoutPreviousSession() {
      await msDataProvider.executeCommand("authenLogout", {});
    },
    async checkBackendServerName() {
      if (this.items.find(item => item.value === this.serverNameDialog.backendServerName.trim())) {
        this.serverNameDialog.errorMessage = this.$t('LOGIN.SERVER_EXIST');
        return;
      }
      this.serverNameDialog.message = [this.$t('APP.CHECKING')];
      try {
        this.modalOptions.loading = true;
        this.serverNameDialog.loading = true;
        await msDataProvider.executeCommand(
            "backendServerNamePing",
            this.serverNameDialog.backendServerName
        );
      } catch (e) {
        if (e && e.message) {
          if (e.message.includes('verify certificate: x509')) {
            this.serverNameDialog.errorMessage = this.$t('ERROR_SERVICE.ERROR_SSL_EXPIRED');
          } else {
            this.serverNameDialog.errorMessage = e.message.includes("Internet Connection Problem") ? this.$t('ERROR_SERVICE.ERROR_SERVICE_HOST_NAME') : this.$t('LOGIN.ERROR_SERVER')
          }
        }
        this.serverNameDialog.loading = false;
        this.modalOptions.loading = false;
        return;
      } finally {
        this.serverNameDialog.message = [];
        this.serverNameDialog.loading = false;
        this.modalOptions.loading = false;
      }

      this.backendServerName = this.serverNameDialog.backendServerName;
      await msDataProvider.executeCommand(
          "backendServerNameSetCurrentValue",
          this.backendServerName
      );
      this.addItem(this.serverNameDialog.backendServerName);
      this.serverNameDialog.createServerNameDialog = false;
      this.prepare();
    },
    addItem(value) {
      this.items.push({text: value, value});
    }
  },
  async created() {
    const backendServerName = await msDataProvider.executeCommand(
        "backendServerNameGetCurrentValue"
    );
    if (backendServerName) {
      this.backendServerName = backendServerName;
      await this.prepare();
    }
    this.setDefaultLoginType();
    this.firstTime = this.$route.query.firstTime || null;
    if (this.type === 'autocomplete') {
      const backendServerNameAllValues = await msDataProvider.executeCommand('backendServerNameGetAllValues');
      if (backendServerNameAllValues.length) {
        this.items = backendServerNameAllValues.map(value => ({text: value, value}));
      }
    }
    this.emit();
    this.isLoggedNotiOpts = {
      title: this.$t('APP.NOTIFICATION'),
      ok: this.$t('APP.YES'),
      cancel: this.$t("LAYOUT.LOGOUT"),
      content: this.$t('LOGIN.HAD_LOGIN_SESSION')
    }
  }
})
